import { Button, Card, Form, Modal, Select, Table } from 'antd';
import React, { useMemo, useState } from 'react';

import { CARD_BODY_STYLES, CARD_HEAD_STYLES } from '../../constants';
import type { ServiceTicketTableData } from '../../types';
import { DUMMY_SERVICE_TICKET_TABLE_DATASOURCE } from './constants';
import { getServiceTicketTableColumns } from './helpers';
import styles from './index.module.scss';

export const ServiceTicketsTable = () => {
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingData, setEditingData] = useState<
    ServiceTicketTableData | undefined
  >(undefined);

  const handleEditButtonClick = (record: ServiceTicketTableData) => {
    setEditingData(record);
    setShowEditModal(true);
  };

  const tableColumns = useMemo(() => {
    return getServiceTicketTableColumns((_, record) => (
      <Button onClick={() => handleEditButtonClick(record)}>編輯</Button>
    ));
  }, []);

  const closeModal = () => setShowEditModal(false);

  const handleModalOk = () => {
    // TODO: 邏輯待寫
    console.log('Update!');
    closeModal();
  };

  const onEditFormFinish = (formValues: { isActive: boolean }) => {
    // TODO: 邏輯待寫
    console.log(formValues);
    closeModal();
  };

  // TODO: 正式串接API後，記得刪除這個log
  console.log(editingData);

  return (
    <>
      <Card
        title="票券功能管理"
        headStyle={CARD_HEAD_STYLES}
        bodyStyle={CARD_BODY_STYLES}
      >
        <Table
          bordered
          rowKey="serviceName" // TODO: 到時候看rowKey需不需要改
          scroll={{ x: 'max-content' }}
          columns={tableColumns}
          dataSource={DUMMY_SERVICE_TICKET_TABLE_DATASOURCE}
        />
      </Card>
      <Modal
        open={showEditModal}
        centered
        destroyOnClose
        onCancel={closeModal}
        onOk={handleModalOk}
        footer={null}
      >
        <Form
          initialValues={{ isActive: !!editingData?.isActive }}
          onFinish={onEditFormFinish}
          layout="vertical"
        >
          <div className={styles.formTitle}>
            <p>服務</p>
            <p>{editingData?.serviceName}</p>
          </div>
          <Form.Item
            label="票卷功能開/關"
            name="isActive"
            rules={[{ required: true }]}
          >
            <Select
              options={[
                { label: '開', value: true },
                { label: '關', value: false },
              ]}
            />
          </Form.Item>
          <Form.Item className={styles.submitButton}>
            <Button htmlType="submit">確認</Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
